import Helper from '@ember/component/helper';
import { htmlSafe } from '@ember/template';
import { escapeString } from '@square/dashboard-utilities/utils/xss';
export default class NewlinesToBr extends Helper {
  compute([body]) {
    return htmlSafe(escapeString(body).replace(/\n\r?/g, '<br>'));
  }
}